import type { AppConfig } from './config-client.schema';

export const config: AppConfig = {
	appDomain: 'https://oima-639de.web.app',

	countryCode: '+31',
	locale: 'en',
	localeTranslations: import('../locales/en/translation-en.json'),

	pwaItems: {
		name: 'Oima',
		short_name: 'Oima',
		description: '',
		theme_color: '#F3764A',
	},

	allowedNumbers: [],

	maxSMSLength: 160,

	firebaseConfig: {
		apiKey: 'AIzaSyBWbF_pRxocPQposQjEDnSdsPQrtUKOiBk',
		authDomain: 'oima-639de.firebaseapp.com',
		projectId: 'oima-639de',
		storageBucket: 'oima-639de.appspot.com',
		messagingSenderId: '160555691200',
		appId: '1:160555691200:web:f88a97388be4fb496f1125',
		measurementId: 'G-Q2QF6NG0RJ',
		vapidKey: '',
		recaptchaV3publicKey: '',
	},

	apiDev: 'http://127.0.0.1:5001/oima-543bb/us-central1/',
	apiProd: 'https://us-central1-oima-639de.cloudfunctions.net/',

	appConfig: {
		hasPrivacyNotice: true,
		hasTandC: true,
		experimental: true,
		shopActionsConfig: {
			userTooLongInactive: 7 * 24 * 60 * 60 * 1000, // one week
		},
		wantsMiddleName: true,
		allowExcelImport: true,
		systemDown: false,
	},

	tenants: [
		{
			id: '1',
			short_title: 'Venlo',
		},
		{
			id: '2',
			short_title: 'Amsterdam',
		},
		{
			id: '3',
			short_title: 'Rotterdam',
		},
		{
			id: '4',
			short_title: 'Utrecht',
		},
	],
};

export enum ShopType {
	AGRIBUSINESS = 'AGRIBUSINESS',
	RETAIL = 'RETAIL',
	WHOLESALE = 'WHOLESALE',
	TENANT = 'TENANT',
	OUTLET = 'OUTLET',
}
